// src/components/admin/employee/payroll/PayrollPager.js
import React from "react";
import "./AdminPayrollViewer.css";

export default function PayrollPager({ canPrev, canNext, onPrev, onNext }) {
  return (
    <div className="apv-pager">
      <button className="apv-pagerBtn" onClick={onPrev} disabled={!canPrev}>
        Prev
      </button>
      <button className="apv-pagerBtn" onClick={onNext} disabled={!canNext}>
        Next
      </button>
    </div>
  );
}
